import Logger from '../lib/logger';
import redirect from '../lib/redirect';

/**
 * Contact Form block (partials/blocks/contact-form.php).
 *
 * Redirects to the block's Success Redirect page (data-redirect) once
 * Contact Form 7 fires `wpcf7mailsent` — i.e. only after the submission
 * validated and the mail went out, not on validation errors or spam.
 * Opens in a new tab when the link is set to (data-redirect-target), falling
 * back to this tab if the browser blocks it.
 * Without a redirect set, CF7's inline success message shows as usual.
 */
class ContactForm {
  constructor(dom) {
    this.NAME = 'ContactForm';
    this.dom = dom;
    this.redirect = dom.dataset.redirect;
    this.redirectTarget = dom.dataset.redirectTarget || '';
  }

  init() {
    if (!this.redirect) return;

    // CF7 dispatches its events on the .wpcf7 wrapper; they bubble up here.
    this.dom.addEventListener('wpcf7mailsent', () => {
      Logger.info(`${this.NAME} > redirecting to ${this.redirect}`);
      redirect(this.redirect, this.redirectTarget);
    });
  }
}

export default ContactForm;
